"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_tabs_1 = require("react-native-paper-tabs");
const react_beforeunload_1 = require("react-beforeunload");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const eventConstants_1 = require("../../constants/eventConstants");
const scheduleSlice_1 = require("../schedules/scheduleSlice");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const queueCommunicationBox_1 = __importDefault(require("../../components/communicationBox/queueCommunicationBox"));
const loanComponent_1 = __importDefault(require("./loanComponent"));
const themes_1 = __importDefault(require("../../styles/themes"));
const callLog_1 = __importDefault(require("../../components/callLog/callLog"));
const officerScheduleTable_1 = __importDefault(require("../../components/schedules/officerScheduleTable"));
const officersSlice_1 = require("../officer/officersSlice");
const constants_1 = require("../../constants/constants");
const campaignSlice_1 = require("./campaignSlice");
const metricsCard_1 = __importDefault(require("../../components/metricsComponent/metricsCard"));
const utils_1 = require("../../utils/utils");
const navigationButton_1 = __importDefault(require("../../components/button/navigationButton"));
const eventQueueBox_1 = __importDefault(require("../../components/event/eventQueueBox"));
const communicationBoxUtils_1 = require("../../components/communicationBox/communicationBoxUtils");
const typesConstants_1 = require("../../constants/typesConstants");
const userComponent_1 = __importDefault(require("./userComponent"));
const callLaterComponent_1 = __importDefault(require("../../components/scheduleAction/callLaterComponent"));
const Campaign = () => {
    const dispatch = useAppDispatch_1.default();
    const { schedule, officerId, officerMetrics, callStatus, callerInbound } = useAppSelector_1.default((state) => ({
        schedule: state.schedule.schedule,
        officerId: state.auth.user.id,
        officerMetrics: state.campaign.officerMetrics,
        callStatus: state.communication.voipCallStatus,
        callerInbound: state.communication.callerInbound,
    }));
    const scheduleId = communicationBoxUtils_1.parseInboundUUID(callerInbound);
    const displayButton = !!scheduleId && (!schedule || schedule.id !== scheduleId);
    const scheduleType = schedule && schedule.external_id_type ? schedule.external_id_type : typesConstants_1.EXTERNAL_ID_TYPE_LOAN;
    const isLoanSchedule = scheduleType === typesConstants_1.EXTERNAL_ID_TYPE_LOAN;
    const onPress = async () => {
        // Dispatch the first action
        const latestSchedule = await dispatch(scheduleSlice_1.getSchedule({ scheduleId })).unwrap();
        // If the first fetch was successful, dispatch the second action
        if (latestSchedule) {
            dispatch(scheduleSlice_1.getScheduleCustomerData({ scheduleId: latestSchedule.id }));
        }
    };
    const getScheduleButtonProps = {
        text: 'Get Details',
        eventName: eventConstants_1.GET_SCHEDULE,
        onPress,
    };
    const clearSchedule = async () => {
        await dispatch(scheduleSlice_1.resetScheduleState());
    };
    react_1.useEffect(() => {
        dispatch(campaignSlice_1.getCampaignMetricsOfficer());
    }, [callStatus]);
    react_beforeunload_1.useBeforeunload(() => dispatch(officersSlice_1.updateOfficerStatus({ status: constants_1.OFFICER_STATUS_PAUSED })));
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignSpaceBetween] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen] },
                schedule && react_1.default.createElement(boxTitle_1.default, { title: `${schedule.partner_name} Schedule` }),
                schedule && react_1.default.createElement(react_native_1.Text, null, schedule.id)),
            !!schedule && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow] },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                    react_1.default.createElement(callLaterComponent_1.default, { schedule: schedule })),
                react_1.default.createElement(navigationButton_1.default, { onPress: clearSchedule, title: "Back", event: eventConstants_1.NAVIGATE_DASHBOARD_BUTTON })))),
        react_1.default.createElement(eventQueueBox_1.default, { buttonProps: displayButton ? getScheduleButtonProps : null }),
        !!officerMetrics && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.ScrollView, { horizontal: true, showsHorizontalScrollIndicator: false, contentContainerStyle: [styles_1.default.flexOne, styles_1.default.flexDirectionRow] },
                react_1.default.createElement(metricsCard_1.default, { label: "Connected", text: officerMetrics.schedules_connected, icon: free_solid_svg_icons_1.faPlayCircle }),
                react_1.default.createElement(metricsCard_1.default, { label: "Promised", text: officerMetrics.schedules_promised, icon: free_solid_svg_icons_1.faSpinner }),
                react_1.default.createElement(metricsCard_1.default, { label: "Dropped", text: officerMetrics.schedules_dropped, icon: free_solid_svg_icons_1.faTrash }),
                react_1.default.createElement(metricsCard_1.default, { label: "Total pause time", text: utils_1.formatDuration(officerMetrics.pause_time, true), icon: free_solid_svg_icons_1.faPauseCircle }),
                react_1.default.createElement(metricsCard_1.default, { label: "Average talk time", text: utils_1.formatDuration(officerMetrics.average_talk_time, true), icon: free_solid_svg_icons_1.faPhoneVolume })))),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(queueCommunicationBox_1.default, null),
            !schedule && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.boxStyles] },
                react_1.default.createElement(react_native_paper_tabs_1.TabsProvider, { defaultIndex: 0 },
                    react_1.default.createElement(react_native_paper_tabs_1.Tabs, { style: styles_1.default.whiteBackground, theme: themes_1.default.tab },
                        react_1.default.createElement(react_native_paper_tabs_1.TabScreen, { label: "Call Logs", icon: "history" },
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTopTen },
                                react_1.default.createElement(callLog_1.default, null))),
                        react_1.default.createElement(react_native_paper_tabs_1.TabScreen, { label: "Connected Schedules", icon: "calendar-clock" },
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTopTen },
                                react_1.default.createElement(officerScheduleTable_1.default, { officerId: officerId }))))))),
            isLoanSchedule ? react_1.default.createElement(loanComponent_1.default, null) : react_1.default.createElement(userComponent_1.default, null))));
};
exports.default = Campaign;
